<div class="logo-container" [class.logo-white]="white">

    <div class="logo-text">
        <div class="brand-name">Cognizant<sup>®</sup></div>
        <div class="brand-tagline">Service excellence suite</div>
    </div>
</div>